import { format } from 'date-fns'

import SvgIcon from '@/components/svg-icon/svgIcon'
import { cn } from '@/libs/tw'
import { translate } from '@/utils/translator'

type TravelPeriodDateSummaryProps = {
	startDate?: Date
	endDate?: Date
	nights: number
	inverted?: boolean
}

export const TravelPeriodDateSummary = ({
	startDate,
	endDate,
	nights,
	inverted,
}: TravelPeriodDateSummaryProps) => {
	return (
		<div
			data-testid="travel-days-summary"
			className={cn(
				'flex w-full items-center justify-between gap-12 rounded-24 border px-16 py-6 md:w-fit md:gap-24',
				inverted
					? 'border-textColor text-textColor md:border-travelPeriod-text md:text-travelPeriod-text'
					: 'border-textColor text-textColor'
			)}
		>
			<div>
				{startDate ? (
					format(startDate, 'dd.MM.yyyy')
				) : (
					<span>{translate('travel-period-arrival')}</span>
				)}
			</div>
			<SvgIcon iconName="arrow-right" className={cn('h-12 w-24 text-current')} />
			<div>
				{endDate ? (
					format(endDate, 'dd.MM.yyyy')
				) : (
					<span>{translate('travel-period-departure')}</span>
				)}
			</div>
			{startDate && endDate && (
				<div>
					(
					{nights === 1
						? translate('travel-period-night', [nights])
						: translate('travel-period-nights', [nights])}
					)
				</div>
			)}
		</div>
	)
}
